import axios from "axios";

export const savePersonaLaboralRequirement = (data, callback) => {
  var promise = axios({
    method: "put",
    url: "/api/personal_laboral_requirements",
    data: data,
    headers: {
      "X-CSRF-TOKEN": window.Hupe8.token
    }
  });
  promise
    .then(response => {
      callback(response);
    })
    .catch(err => {
      callback(err.response);
    });
};

